import SubmitPasswordReset from './SubmitPasswordReset';

export default SubmitPasswordReset;